import React from 'react';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

export default function SurveyStepper(props) {

    const theme = useTheme();
    const activeStep = props.currentPage

    const nextButton = () => {
      if (activeStep < props.length - 1) {
        return <Button size="small" onClick={props.incrementPage}>
          Weiter
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </Button>
      } else {
        return <Button size="small" onClick={props.handleModalOpen} disabled={props.isFinished}>
          Abschließen
        </Button>
      }
    }
  
    return (
      <MobileStepper
        variant="dots"
        steps={props.length}
        position="static"
        activeStep={activeStep}
        sx={{ maxWidth: 400, flexGrow: 1, width: "100%" }}
        nextButton={nextButton()}
        backButton={
          <Button size="small" onClick={props.decrementPage} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Zurück
          </Button>
        }
      />
    );
}